// app/javascript/controllers/sortable_controller.js
import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { patch } from "@rails/request.js"

export default class extends Controller {
  connect() {
    // Sortable.create(this.element, {
    this.sortable = Sortable.create(this.element, {
        animation: 150,
      onEnd: async () => {
        const ids = Array.from(this.element.children).map(child => child.dataset.id)

        await patch("/manage_spaces/sort", {
          body: { space_ids: ids }
        })
      }
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }
}
